import { render, staticRenderFns } from "./message-compose.vue?vue&type=template&id=31a5984b&"
import script from "./message-compose.vue?vue&type=script&lang=js&"
export * from "./message-compose.vue?vue&type=script&lang=js&"
import style0 from "./message-compose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports